$(document).ready(function() {
    $('.team-member-item').on('click mouseover', function(event) {
        // Prevent default link behaviour
        if($(this).attr('href') != '/team') {
            event.preventDefault();
        }

        // Add active class to team member
        $otherTeamMember = $('.active');
        $otherTeamMember.removeClass("active");
        $(this).addClass('active');

        // Find descriptions and hide them
        $otherDescription = $(this).closest('.info-snippets').find(".team-member-description-wrapper");
        $otherDescription.addClass('d-none');

        // Get description from linked team member
        $link = $(this).attr('href');
        $description = $('.info-snippets').find("div[data-id=" + $link + "]");

        // Show descriptions for clicked team member
        if($description.hasClass('d-none')) {
            $description.removeClass('d-none');
        } else {
            $description.addClass('d-none');
        }
    });
});

// Mobile Carousel - Sync description with active team member
$(document).ready(function() {

    $slick_count = 1;

    $('.slick-next').click(function(event) {

        // Total number of team members
        $teamMemberDescriptionWrapper = $(this).closest('.info-snippets').find('.team-member-description-wrapper');
        $numberOfTeamMembers = $teamMemberDescriptionWrapper.attr('data-max');

        if($slick_count >= $numberOfTeamMembers) {
            $slick_count = 1
        } else {
            $slick_count = $slick_count + 1;
        }

        // Remove active class from old description and hide
        $otherTeamMember = $('.active');
        $otherTeamMember.removeClass('active');
        $otherTeamMember.addClass('d-none');

        $otherTeamMemberDescription = $(this).closest('.info-snippets').find('active');
        $otherTeamMemberDescription.addClass('d-none');

        // Add active class to new description and show
        $teamMemberDescription = $(this).closest('.info-snippets').find("div[data-count=" + $slick_count + "]");
        $teamMemberDescription.addClass('active');
        $teamMemberDescription.removeClass('d-none');

    });

    $('.slick-prev').click(function(event) {

        // Total number of team members
        $teamMemberDescriptionWrapper = $(this).closest('.info-snippets').find('.team-member-description-wrapper');
        $numberOfTeamMembers = $teamMemberDescriptionWrapper.attr('data-max');

        if($slick_count == 1) {
            $slick_count = $numberOfTeamMembers;
        } else {
            $slick_count = $slick_count - 1;
        }

        // Remove active class from old description and hide
        $otherTeamMember = $('.active');
        $otherTeamMember.removeClass('active');
        $otherTeamMember.addClass('d-none');

        $otherTeamMemberDescription = $(this).closest('.info-snippets').find('active');
        $otherTeamMemberDescription.addClass('d-none');

        // Add active class to new description and show
        $teamMemberDescription = $(this).closest('.info-snippets').find("div[data-count=" + $slick_count + "]");
        $teamMemberDescription.addClass('active');
        $teamMemberDescription.removeClass('d-none');

    });

});